import React from 'react'
import PropTypes from 'prop-types'

import SortableSectionsWrapper from 'agency/digital_renderer/components/SortableSectionsWrapper'
import ToggleableSection from 'agency/digital_renderer/components/ToggleableSection'

import Header from './components/Header'
import Welcome from './components/Welcome'
import Download from './components/Download'
import styles from './styles.scss'

const RealhubSortable = (props) => {
  const {
    agents, artwork, brand, campaign, campaignProposal, campaignSaleMethod, contacts, editing, images,
  } = props

  const registeredComponents = [
    <ToggleableSection key="header" sectionId="header"><Header brand={brand} sortDisabled /></ToggleableSection>,
    <Welcome key="welcome" campaignProposal={campaignProposal} />,
    <Download key="download" artwork={artwork} />,
  ]

  return (
    <div>
      <SortableSectionsWrapper
        components={registeredComponents}
        isSortable
        render={({ sortedComponents }) => sortedComponents.map(component => component)}
      />
    </div>
  )
}

RealhubSortable.propTypes = {
  agents: PropTypes.object.isRequired,
  artwork: PropTypes.object.isRequired,
  brand: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  campaignProposal: PropTypes.object.isRequired,
  campaignSaleMethod: PropTypes.object.isRequired,
  contacts: PropTypes.object.isRequired,
  editing: PropTypes.bool,
  images: PropTypes.object.isRequired,
}

export default RealhubSortable
